// extracted by mini-css-extract-plugin
module.exports = {"bottomImage":"BottomImage_bottomImage__LgXY2"};